import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CutoffsFieldsComponent from './Component';

import getDistributionFunctionsByType from 'calculators/distributions';
import { getCutoffs } from 'store/scenes/distributions/cutoffs/selectors';
import { setCutoffs } from 'store/scenes/distributions/cutoffs/actions';
import { setBinomialAlpha } from 'store/scenes/distributions/binomialAlpha/action';
import { getBinomialAlpha } from 'store/scenes/distributions/binomialAlpha/selectors';

import { isRequiredFloatGreaterThanOrEqual, makeCutoffOrZscoreIntersectionValidator } from 'utilities/validators';

import {
  setLeftCutoff, setRightCutoff
} from 'store/form/distributions/actions';

import {
  getTailType, isLeftTailSelected, isRightTailSelected, isEqualTailSelected
} from 'store/scenes/distributions/chart/selectors';

import {
  getDistributionsFormValues
} from 'store/form/distributions/selectors';

class CutoffsFieldsContainer extends React.PureComponent {

    handleLeftCutoffChange = (_, newLeftCutoff) => {
      this.props.calculateProbability({
        type: 'left', value: newLeftCutoff
      });
    };

    handleRightCutoffChange = (_, newRightCutoff) => {
      this.props.calculateProbability({
        type: 'right', value: newRightCutoff
      });
    };

    validateLeftCutoffFn = (value, allValues) => {
      const rangeValidator = isRequiredFloatGreaterThanOrEqual(0);
      const intersectValidator = makeCutoffOrZscoreIntersectionValidator(
        +value,
        +allValues.bRightCutoff,
        this.props.tailType,
        true
      );

      if (rangeValidator(value)) {
        return rangeValidator(value);
      } else {
        return intersectValidator;
      }
    };

    validateRightCutoffFn = (value, allValues) => {
      const rangeValidator = isRequiredFloatGreaterThanOrEqual(0);
      const intersectValidator = makeCutoffOrZscoreIntersectionValidator(
        +allValues.bLeftCutoff,
        +value,
        this.props.tailType,
        true
      );

      if (rangeValidator(value)) {
        return rangeValidator(value);
      } else {
        return intersectValidator;
      }
    };

    render () {
      return (
        <CutoffsFieldsComponent
          isEqualCutoffChosen={this.props.isEqualCutoffChosen}
          isCenterCutoffChosen={this.props.isCenterCutoffChosen}
          isLeftCutoffFieldVisible={this.props.isLeftCutoffFieldVisible}
          isRightCutoffFieldVisible={this.props.isRightCutoffFieldVisible}
          onLeftCutoffChange={this.handleLeftCutoffChange}
          onRightCutoffChange={this.handleRightCutoffChange}
          validateLeftCutoffFn={this.validateLeftCutoffFn}
          validateRightCutoffFn={this.validateRightCutoffFn}
          binomialAlpha={this.props.binomialAlpha}
        />
      );
    }
}


CutoffsFieldsContainer.propTypes = {
  tailType: PropTypes.string.isRequired,
  binomialAlpha: PropTypes.number.isRequired,
  calculateProbability: PropTypes.func.isRequired,
  isEqualCutoffChosen: PropTypes.bool.isRequired,
  isCenterCutoffChosen: PropTypes.bool.isRequired,
  isLeftCutoffFieldVisible: PropTypes.bool.isRequired,
  isRightCutoffFieldVisible: PropTypes.bool.isRequired
};


const mapStateToProps = state => ({
  isLeftCutoffFieldVisible: isLeftTailSelected(state),
  isRightCutoffFieldVisible: isRightTailSelected(state),
  isCenterCutoffChosen: getTailType(state) === 'center',
  isEqualCutoffChosen: isEqualTailSelected(state),
  binomialAlpha: getBinomialAlpha(state),

  tailType: getTailType(state)
});

const mapDispatchToProps = {
  calculateProbability: cutoff => (dispatch, getState) => {
    const state = getState();
    const tailType = getTailType(state);
    const type = 'binomial';
    const fns = getDistributionFunctionsByType(type);
    const distributionFormValues = getDistributionsFormValues(state);

    let leftCutoffX = null;
    let rightCutoffX = null;

    if (cutoff.type === 'left') {
      leftCutoffX = cutoff.value;
      rightCutoffX = getCutoffs(state) && getCutoffs(state).right.x;
    } else {
      rightCutoffX = cutoff.value;
      leftCutoffX = getCutoffs(state) && getCutoffs(state).left.x;
    }

    const alpha = fns.getAlphaByCutoffsAndTailType(distributionFormValues, leftCutoffX, rightCutoffX, tailType);
    const cutoffs = fns.getCutoffsByCutoffXValues(distributionFormValues, leftCutoffX, rightCutoffX);

    dispatch([
      setCutoffs(cutoffs),
      setBinomialAlpha(alpha),

      setLeftCutoff(+leftCutoffX),
      setRightCutoff(+rightCutoffX)
    ]);
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(
  CutoffsFieldsContainer
);
